import React, { useState,useEffect } from 'react'
import { useLocation,useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import GetRequest from '../../../../service/GetRequest';
import { ProgressSpinner } from 'primereact/progressspinner';
import verfiedIcon from '../../../../assets/icons/verfied.png';
import failureIcon from '../../../../assets/icons/failure.png';
import CookieHandler from '../../../LandingPage/Authentication/CookieHandler';


const PaymentSuccessPage = () => {
    const navigate = useNavigate();
    const userId = CookieHandler.getCookie("userid");

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const sessionId = searchParams.get('session_id');

    const [isPaymentSuccess, setIsPaymentSucess] = useState(false);
    const [isloading, setIsLoading] = useState(true);

    
    

    useEffect(() => {
        // Simulate a payment verification process
        // Replace this with your actual payment verification logic
        const verifyPayment = () => {
            // Example: Check if the session ID is valid
            if (sessionId) {
                // If the session ID is valid, consider it a successful payment
                GetRequest("v1/store-management-service/view/manager/subscription/payment/verify?sessionId=" + sessionId,true)
                .then(response => {
                    if (!response || response === undefined) {
                        setIsLoading(false);
                    } else {
                        if(response.isPaymentSuccess ===true){
                            setIsPaymentSucess(true);
                            setIsLoading(false);
                            setTimeout(() => {
                                navigate("/store/complete/profile");
                              }, 5000);
                        } else {
                            setIsLoading(false);
                            setIsPaymentSucess(false);
                        }                        
                    }
                })
                .catch(error => {
                    console.error("Error fetching store data:", error);
                    setIsLoading(false);
                });

            } else {
                // If the session ID is not valid, consider it a failed payment
                setIsPaymentSucess(false);
                setIsLoading(true);
            }
        };

        // Call the function to verify the payment when the component mounts
        verifyPayment();
    }, [sessionId,userId,navigate,isPaymentSuccess]);



  return (
      <div className="background-white">
        <div className="background-white-sub-container"> 
        <div className='centralised-text'>

        {isloading ? (
        <div className='centralised-text'>
            <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>
            <div className='centralised-text'>
             <ProgressSpinner style={{width: '80px', height: '80px'}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"/>
                </div>
            <br/><br/>
            <div className='centralised-text extra-large-text'>Please wait while verifying your payment</div>
        </div>
        ) : (
        isPaymentSuccess ? (
            <div className='centralised-text'>
            <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>
            <div className='centralised-text'>
            <img
                loading="lazy"
                alt="icon"
                srcSet={verfiedIcon}
                className="shrink-0 rounded-lg aspect-[1.02] w-[45px]"
                style={{ height: '80px', width: '80px' }}
              />
            </div>
            <br/><br/>
            <div className='centralised-text extra-large-text'>Payment verified, redirecting in 5 seconds</div>
            <br/><br/>If redirection fails, please click on the below button to perform a manual redirect
            <br/><br/><div className='centralised-text'><Button onClick={() => navigate("/store/complete/profile")} variant="soft" label="Continue"/>
        </div></div>
            
        ) : (
            <div className='centralised-text'>
            <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>
            <div className='centralised-text'>
            <img
                loading="lazy"
                alt="icon"
                srcSet={failureIcon}
                className="shrink-0 rounded-lg aspect-[1.02] w-[45px]"
                style={{ height: '80px', width: '80px' }}
              />
            </div>
            <br/><br/>
            <div className='centralised-text extra-large-text'>Payment verified failed, please retry payment</div>
            <br/><br/>If amount has been deducted from you, don't worry will be credited back to your account.
            <br/><br/><div className='centralised-text'><Button onClick={() => navigate("/store/package-selection")} variant="soft" label="Continue"/>
        </div></div>
                   )
        )}


    </div></div></div>
  )
}

export default PaymentSuccessPage
